export const LIST_PROTECTION_LIMIT = 500
export const PREVIEW_LIST_LIMIT = 150
export const FILTER_STATUS_CHUNK_SIZE = 50
export const FILTER_MUSICAL_STATUS_CHUNK_SIZE = 15
export const LARGE_LIST_WARNING_THRESHOLD = 1000
export const LARGE_BOOK_INDEX_THRESHOLD = 5000
export const CATALOG_PAGE_SIZE = 200
export const PLAYLIST_MAX_ITEMS = 200
export const BULK_SELECTION_LIMIT = 500
export const BODY_LRU_CACHE_SIZE = 50
export const MIGRATION_BATCH_SIZE = 500
export const SYNC_SHARD_SIZE = 2000

export const STORAGE_FLAG_USE_CATALOG = 'bookstorage_use_catalog_storage'
export const STORAGE_FLAG_USE_SHARDED_SYNC = 'bookstorage_use_sharded_sync'
export const STORAGE_SCHEMA_VERSION_KEY = 'bookstorage_schema_version'
export const CURRENT_SCHEMA_VERSION = 2
